// extracted by mini-css-extract-plugin
export default {"metadataContainer":"eventDetail_metadataContainer__xaumb","inputOutputContainer":"eventDetail_inputOutputContainer__ZK-Ig"};